import { PATREON_DONATE_URL, PAYPAL_DONATE_URL } from "routes/CONSTANTS";

const DonationOptions = () => {
  return (
    <div className="md:px-12 xl:px-28 px-5 md:py-16 py-12">
      <div className="flex flex-col items-center justify-center md:gap-10 gap-6">
        <p className="text-3xl md:text-5xl font-bold text-[#3C4E40] text-center">
          Support Us on PayPal or Patreon
        </p>
        <p className="text-base md:text-xl text-[#3C4E40] text-center max-w-3xl leading-8">
          Choose the platform that works best for you. One-time and recurring donations are welcome
          on both PayPal and Patreon.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 w-full max-w-2xl">
          <a
            href={PAYPAL_DONATE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 text-white text-lg md:text-xl bg-[#0070BA] hover:bg-[#005ea6] py-4 px-6 flex items-center justify-center rounded-md font-medium"
          >
            Donate with PayPal
          </a>
          <a
            href={PATREON_DONATE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 text-white text-lg md:text-xl bg-[#FF424D] hover:bg-[#e03b45] py-4 px-6 flex items-center justify-center rounded-md font-medium"
          >
            Support on Patreon
          </a>
        </div>
      </div>
    </div>
  );
};

export default DonationOptions;
